import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, RadioGroup, Radio } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    packageCode: 50,
    packageName: 50,
    serviceName: 50,
    serviceAmount: 15,
};
const IntervalList = Array.from({ length: 60 }, (_, i) => (i + 1).toString());

export default function AddPackageConfig() {
    const location = useLocation();
    const PackId = location.state?.id;
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        searchList: [],
        serviceSearch: '',
        serviceSearchData: null,
        selectedUnit: '',
        packageCode: '',
        packageName: '',
        packageAmount: '',
        serviceName: '',
        serviceAmount: 0,
        intervalTime: null,
        intervalAmount: 0,
        // doctorShareRupee: '',
        // doctorSharePercent: '',
        // hospitalShareRupee: '',
        // hospitalSharePercent: '',
        ModuleType: [],
        appliesTo: null
    });
    const [isActive, setIsActive] = useState(true);
    const [serviceList, setServiceList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [serviceDetails, setServiceDetails] = useState([]);
    const [totalPackage, setTotalPackage] = useState(0);
    const [packageLineItem, setPackageLineItem] = useState(null)
    const [apiDeleteIDs, setapiDeleteIDs] = useState(null)
    const [localDeleteIDs, setlocalDeleteIDs] = useState(null)
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Corporate Service Configuration", "SubTab")?.editAccess
    const [billingDisplay, setBillingDisplay] = useState({
        selectedBillingDisplay: 'Package Name'
    })
    useEffect(() => {
        if (PackId) {
            getPackageIndividual();
        }
    }, [PackId]);

    useEffect(() => {
        if (formState?.serviceSearch?.length > 0) {
            getSearchData();
        }
    }, [formState?.serviceSearch])

    useEffect(() => {
        getModuleList();
    }, [])

    const getSearchData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.CONFIGURATION_SERVICE_SEARCH + `?search_key=${formState?.serviceSearch}&module_type=${formState?.appliesTo}&all_doctor=${false}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({ ...prevState, searchList: response.data.data || [], }));
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPackageIndividual = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_PACKAGE_CONFIGURATION + `?get_type=individual&package_id=${PackId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const serviceData = response.data.data || [];
                        setServiceList(serviceData);
                        setFormState((prevState) => ({
                            ...prevState,
                            packageCode: response.data.data?.package_code,
                            packageName: response.data.data?.package_name,
                            appliesTo: response.data.data?.apply_for
                        }));
                        setIsActive(response.data.data?.is_active)
                        setServiceDetails(serviceData?.line_item || [])
                        const totalPackageAmount = serviceData?.line_item.reduce((acc, item) => acc + (item?.service_amount || 0), 0);
                        setTotalPackage(totalPackageAmount);
                        const packageLineItemIds = serviceData?.line_item
                            .map(service => service.package_line_item_id)
                            .filter(id => id !== null && id !== undefined);
                        setPackageLineItem(packageLineItemIds);
                        setisloader(false)
                        setBillingDisplay((prev) => ({ ...prev, selectedBillingDisplay: response?.data?.data?.billing_display ?? 'Package Name'}))
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getModuleList = () => {
        try {
            RestAPIService.getAll(Serviceurls.MODULE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || [];
                        setFormState((prev) => ({
                            ...prev,
                            ModuleType: (Object.keys(ModuleData))
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'serviceSearchData':
                setFormState((prevState) => ({
                    ...prevState,
                    "serviceSearchData": val,
                    'departmentType': val?.department_type,
                    'serviceHeadCode': val?.service_head_code,
                    'serviceHead': val?.service_head_name,
                    'serviceName': val?.service_name,
                    'serviceCode': val?.service_code,
                    'selectedUnit': val?.unit_type,
                    'serviceId': val?.id
                }));
                break
            case 'appliesTo':
                setFormState((prevState) => ({
                    ...prevState,
                    appliesTo: val,
                    serviceSearchData: null,
                    searchList: []
                }));
                break
            case 'intervalTime':
                setFormState((prevState) => ({
                    ...prevState,
                    [name]: val
                }));
            case 'intervalTime':
                setFormState((prevState) => ({
                    ...prevState,
                    [name]: name === 'intervalTime' ? Number(val) : val
                }));
        }
    }

    const [temp, setTemp] = useState({ serviceAmount: 0, doctorShareRupee: '', doctorSharePercent: '', hospitalShareRupee: '', hospitalSharePercent: '' })

    const onChangeHandler = (e, name) => {
        let { value } = e.target;

        const isNumericField = [
            "serviceAmount",
            "doctorShareRupee",
            "doctorSharePercent",
            "hospitalShareRupee",
            "hospitalSharePercent"
        ].includes(name);

        if (isNumericField) {
            value = value.replace(/[^0-9 .]/g, "");  // Remove non-numeric characters execpt decimal point
            value = value.replace(/^0+/, "");        // Remove leading zeros

            // Prevent multiple decimals
            if ((value.match(/\./g) || []).length > 1) {
                return;
            }

            // Restrict decimal values to 2 digits
            if (value.includes(".")) {
                const [integer, decimal] = value.split(".");
                if (decimal.length > 2) {
                    return;  // Prevent typing more than 2 digits after decimal
                }
            }

            // Cap percentages at 100%
            if (name.includes("Percent")) {
                const numValue = parseFloat(value);
                if (!isNaN(numValue) && numValue > 100) {
                    value = "100";
                }
            }
        }

        // Update state with sanitized value
        let updatedState = { ...formState, [name]: value || "" };
        let updatedTemp = { ...temp, [name]: value || "" };

        const serviceAmount = parseFloat(updatedState.serviceAmount) || 0;

        updatedTemp.serviceAmount = serviceAmount // temp state for updating the accurate percentage values in temp

        if (serviceAmount > 0) {
            const doctorRupee = parseFloat(updatedState.doctorShareRupee) || 0;
            const hospitalRupee = parseFloat(updatedState.hospitalShareRupee) || 0;
            const doctorPercent = parseFloat(updatedState.doctorSharePercent) || 0;
            const hospitalPercent = parseFloat(updatedState.hospitalSharePercent) || 0;


            // Handle share recalculations dynamically
            if (name === "doctorShareRupee") {
                const doctorShare = Math.min(doctorRupee, serviceAmount);
                const doctorPercent = (doctorShare / serviceAmount) * 100;

                const hospitalShare = serviceAmount - doctorShare;
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;

                // Temp states update for doc share
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;

                updatedState.doctorShareRupee = value > serviceAmount ? serviceAmount : value
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2)
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)

            } else if (name === "hospitalShareRupee") {
                const hospitalShare = Math.min(hospitalRupee, serviceAmount);
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;

                const doctorShare = serviceAmount - hospitalShare;
                const doctorPercent = (doctorShare / serviceAmount) * 100;

                // Temp states update for hos share 
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;

                updatedState.hospitalShareRupee = value > serviceAmount ? serviceAmount : value
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
                updatedState.doctorShareRupee = (doctorShare).toFixed(2)
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)

            } else if (name === "doctorSharePercent") {
                const docPercent = Math.min(parseFloat(value) || 0, 100);
                const doctorShare = (serviceAmount * docPercent) / 100;

                const hospitalShare = serviceAmount - doctorShare;
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;

                // Temp states update for doc percent
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = docPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;

                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = value;
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2);

            } else if (name === "hospitalSharePercent") {
                const hospPercent = Math.min(parseFloat(value) || 0, 100);
                const hospitalShare = (serviceAmount * hospPercent) / 100;

                const doctorShare = serviceAmount - hospitalShare;
                const doctorPercent = (doctorShare / serviceAmount) * 100;

                // Temp states update for hos percent
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;

                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = value;
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2);
            }
        }

        // Update both states
        setTemp(updatedTemp);
        setFormState(updatedState);
    };

    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        let IntValue = ["doctorShareRupee", "hospitalShareRupee", 'doctorSharePercent', 'hospitalSharePercent'].includes(name);

        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val ? val : IntValue ? 0 : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            Symbol === 'rupee' ?
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography> :
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>%</Typography>

                    } : null}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width, disable = false) => {
        return (
            <Box>
                <Autocomplete
                    clearIcon
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={(name === 'serviceSearchData' && !formState?.appliesTo) || disable || (name === 'appliesTo' && PackId) || (name === 'appliesTo' && serviceDetails?.length > 0)}
                    getOptionLabel={(option) => {
                        if (name === 'serviceSearchData') {
                            return `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`;
                        }
                        const moduleMapping = {
                            IP: "IN PATIENT",
                            OP: "OUT PATIENT",
                            IP_OP: "BOTH IP & OP",
                            LAB: "LABORATORY"
                        };

                        return moduleMapping[option] || option;
                    }}
                    value={val}
                    onInputChange={(e, newInputValue) => {
                        if (name === 'serviceSearchData') {
                            newInputValue && setFormState((prevState) => ({
                                ...prevState,
                                serviceSearch: newInputValue
                            }));
                        }
                    }}
                    onChange={(event, newValue) => {
                        onChangeAuto(event, newValue, name);
                    }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                {/* <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip> */}
            </Box>
        )
    }

    const grpDelete = () => {
        setisDelete(true)
    }

    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = serviceDetails?.filter((row) => selectedIDs.has(row.sno));
            let finalData = selectedRows.map(item => ({
                id: item.service_details_id,
                package_line_item_id: item.package_line_item_id || null
            }));
            setdelIDs(finalData);
            setapiDeleteIDs(finalData.filter(item => item.package_line_item_id).map(item => item.package_line_item_id));
            setlocalDeleteIDs(finalData.filter(item => !item.package_line_item_id).map(item => item.id));

        }

        serviceDetails?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.30,
                renderCell: (params) => {
                    const serviceHeadName = params.row.service_head_name || params.row.service_head;
                    return (serviceHeadName ? serviceHeadName?.length > 35 || params.row.service_head_code?.length > 35 ?
                        <Tooltip placement="top" title={`${params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}${serviceHeadName}`}><Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName.slice(0, 33) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName}</Typography> : '-')
                }
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.30,
                renderCell: (params) => (params.row.service_name ? params.row.service_name?.length > 35 || params.row.service_code?.length > 35 ?
                    <Tooltip placement="top" title={`${params.row.service_code ? params.row.service_code + ' - ' : ''}${params.row.service_name}`}><Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name.slice(0, 33) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name}</Typography> : '-')
            },
            {
                field: 'service_amount', headerName: 'Service Amount', flex: 0.25,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_amount ? AmountFormat(params?.row?.service_amount)?.replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.15,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => { handleEdit(params.row, params.api.getRowIndexRelativeToVisibleRows(params.id)) }} />
                        </Stack>
                    </Stack>)
            },
        ]

        const handleEdit = (row, index) => {
            // Extract the time parts
            const intervalParts = row.interval_time?.split(':');
            let minutes = 0;

            if (intervalParts?.length === 3) {
                const hrs = parseInt(intervalParts[0], 10);
                const mins = parseInt(intervalParts[1], 10);

                // Convert to total minutes (to handle 01:00:00 as 60 minutes)
                minutes = (hrs * 60) + mins;
            }

            setFormState((prevState) => ({
                ...prevState,
                serviceSearchData: row,
                serviceName: row.service_name,
                serviceAmount: row.service_amount,
                intervalAmount: row.interval_amount,
                selectedUnit: row.unit_type,
                intervalTime: minutes,   // Store in total minutes
                editIndex: index,
            }));
            setEditMode(true);
        };


        return (
            <Box sx={{ height: '42vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={serviceDetails}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const AddTable = () => {
        let totalMinutes = formState.intervalTime || 0;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (!formState?.serviceSearchData?.service_details_id) {
            return errorMessage("kindly select any services");
        }

        let newData = {
            package_line_item_id: formState?.serviceSearchData?.package_line_item_id || null,
            service_details_id: formState.serviceSearchData?.service_details_id,
            service_name: formState.serviceSearchData?.service_name || formState?.serviceName,
            service_head_name: formState.serviceSearchData?.service_head_name || formState?.serviceHead,
            service_head_code: formState.serviceSearchData?.service_head_code || formState?.serviceHeadCode,
            service_code: formState.serviceSearchData?.service_code || formState?.serviceCode,
            service_amount: formState.serviceAmount ? parseInt(formState.serviceAmount) : 0,
            unit_type: formState.selectedUnit ? formState.selectedUnit : 0,
            interval_time: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`,
            interval_amount: formState.intervalAmount ? parseInt(formState.intervalAmount) : 0,
            // doctor_share_percent: formState.doctorSharePercent ? Number(temp.doctorSharePercent) : 0,
            // hospital_share_percent: formState.hospitalSharePercent ? Number(temp.hospitalSharePercent) : 0,
            // doctor_share_amount: formState.doctorShareRupee ? Number(temp.doctorShareRupee) : 0,
            // hospital_share_amount: formState.hospitalShareRupee ? Number(temp.hospitalShareRupee) : 0,
        };

        let errorState = false;

        setServiceDetails((prevState) => {
            let updatedState;
            const existsIndex = prevState.findIndex(item => item.service_details_id === newData.service_details_id);
            if (newData.package_line_item_id) {
                // Update the service amount based on package_line_item_id if it exists
                updatedState = prevState.map(item =>
                    item.package_line_item_id === newData.package_line_item_id
                        ? { ...item, service_amount: newData.service_amount, interval_time: newData.interval_time, interval_amount: newData.interval_amount }
                        : item
                );
            } else if (editMode) {
                // Allow update in edit mode
                setEditMode(false);
                updatedState = prevState.map((item, index) =>
                    index === formState?.editIndex ? { ...item, service_amount: newData.service_amount, interval_time: newData.interval_time, interval_amount: newData.interval_amount } : item
                );
            } else {
                // Prevent duplicate services
                if (existsIndex !== -1) {
                    errorMessage("Service already exists!");
                    errorState = true;
                    return prevState; // No update, no clearing states
                }
                updatedState = [...prevState, newData];
            }

            // **Calculate the total package amount**
            const totalAmount = updatedState.reduce((sum, item) => sum + parseFloat(item.service_amount), 0);
            setTotalPackage(totalAmount);

            return updatedState;
        });

        // Clear form fields only if no error
        if (!errorState) {
            setFormState((prevState) => ({
                ...prevState,
                serviceName: '',
                serviceAmount: 0,
                serviceSearchData: null,
                searchList: [],
                serviceSearch: '',
                serviceHead: '',
                serviceHeadCode: '',
                serviceCode: '',
                intervalTime: null,
                intervalAmount: 0,
                selectedUnit: ''
                // doctor_share_percent: 0,
                // hospital_share_percent: 0,
                // doctor_share_amount: 0,
                // hospital_share_amount: 0,
            }));
        }
    };
    const AddPackageData = () => {
        try {
            if (!formState?.packageName || !formState?.appliesTo) {
                return errorMessage('Please Enter All mandatory fields');
            }

            let data = {
                package_id: PackId || null,
                package_name: (formState?.packageName ?? '').trim(),
                package_code: formState?.packageCode || '',
                package_amount: totalPackage,
                apply_for: formState?.appliesTo,
                is_active: isActive,
                line_item: serviceDetails,
                billing_display: billingDisplay.selectedBillingDisplay
            }

            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_PACKAGE_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        successMessage(response.data.message)
                        // setFormState((prevState) => ({ ...prevState, serviceName: '', serviceAmount: '', serviceSearchData: null, searchList: [], serviceSearch: '' }));
                        history.push("/Settings/NewService/PackageConfig")
                        setBillingDisplay((prev) => ({ ...prev, selectedBillingDisplay: 'Package Name' }))
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }


    const deletePackage = () => {
        try {
            setisloader(true);
            RestAPIService.delete(`${Serviceurls.NEW_PACKAGE_CONFIGURATION}?delete_type=package&package_id=${PackId}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        history.push("/Settings/NewService/PackageConfig");
                    }
                })
                .catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                })
                .finally(() => {
                    setisloader(false);
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e.message);
        }
    }

    const deleteIndivudualData = () => {
        try {
            setisloader(true);
            // if all rows are selcted it will delete the entire package
            if (Array.isArray(delIDs) && Array.isArray(packageLineItem) && Array.isArray(apiDeleteIDs)) {
                if (((delIDs.length === packageLineItem.length) || (delIDs.length === serviceDetails.length)) && apiDeleteIDs.length > 0) {
                    deletePackage();
                    return;
                }
            }
            // this will remove the row locally without any api call
            if (Array.isArray(localDeleteIDs) && localDeleteIDs.length > 0) {
                setServiceDetails((prevState) =>
                    prevState.filter(item => !localDeleteIDs.includes(item.service_details_id))
                );
            }

            if (Array.isArray(apiDeleteIDs) && apiDeleteIDs.length > 0) {
                RestAPIService.delete(
                    `${Serviceurls.NEW_PACKAGE_CONFIGURATION}?delete_type=individual&id=${apiDeleteIDs.join(',')}`,
                    {}
                )
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            successMessage(response.data.message);
                            closeFilter();
                            getPackageIndividual(PackId);
                        }
                    })
                    .catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message);
                        } else {
                            errorMessage(e.message);
                        }
                    })
                    .finally(() => {
                        setisloader(false);
                    });
            } else {
                setisloader(false);
                closeFilter();
            }
        } catch (e) {
            setisloader(false);
            errorMessage(e.message);
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filterdepartment}
                            onChange={(event, newValue) => {
                                setFilterDepartment(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    const prevent = () => {
        history.push("/Settings/NewService/PackageConfig")
    }

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Package Configuration'}</Typography>
            </Box>

            <Box component={'div'} sx={{ height: '18vh', width: '93vw', backgroundColor: 'white', marginTop: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Package Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "center", height: "8vh", paddingLeft: "0.5vw" }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "8vh", paddingLeft: "0.5vw" }}>
                        {textBox("Package Code", 'packageCode', formState?.packageCode, '15vw', true)}
                        {textBox("Package Name*", 'packageName', formState?.packageName, '15vw')}
                        {autoComplete("Applies To *", 'appliesTo', formState?.appliesTo, formState?.ModuleType, '15vw')}
                        {textBox("Total Package Amount", 'packageAmount', totalPackage.toFixed(2), '15vw', true)}
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' />} disabled={!PackId} label={"Active"} />
                    </div>
                    <div>
                        {delIDs?.length > 0 && <Button size='small' variant='contained' color='error' sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} disabled={!commonDisable} onClick={() => { grpDelete() }}>Delete</Button>}
                        <Button size='small' variant='contained' disabled={serviceDetails?.length <= 0 && !commonDisable} sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { AddPackageData() }}>{PackId ? 'Update' : 'Save'}</Button>
                    </div>
                </Box>
                <Box component={'div'} display={'flex'} alignItems={'center'} ml={'1rem'}>
                    <Typography fontSize={'0.9rem'} fontWeight={600} mr={'1rem'}>In Billing Display by?</Typography>
                    <RadioGroup
                        row
                        value={billingDisplay.selectedBillingDisplay}
                        onChange={(e) => {
                            setBillingDisplay((prev) => ({ ...prev, selectedBillingDisplay: e.target.value }))
                        }}
                    >
                        <FormControlLabel value="Package Name" control={<Radio size='small' />} label="Package Name" />
                        <FormControlLabel value="Service Head" control={<Radio size='small' />} label="Service Head" />
                        <FormControlLabel value="Service Name" control={<Radio size='small' />} label="Service Name" />
                    </RadioGroup>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '15vh', width: '93vw', backgroundColor: 'white', mt: "0.5vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Service Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', flexWrap: "wrap", alignItems: "center", height: "10vh", paddingLeft: "0.5vw" }}>
                    {autoComplete("Search Service Code/Head/Name*", 'serviceSearchData', formState?.serviceSearchData, formState?.searchList, '30.3vw', editMode)}
                    {textBox("Service Name", 'serviceName', formState?.serviceName, '15vw', true)}
                    {textBox("Service Amount", 'serviceAmount', formState?.serviceAmount, '15vw', formState?.serviceSearchData ? false : true)}
                    {
                        formState?.selectedUnit === 'Hrs' ? <>
                            {autoComplete(`Select Interval Time*`, 'intervalTime', formState?.intervalTime, IntervalList, '7.35vw')}
                            {textBox(`Interval Amount`, 'intervalAmount', formState?.intervalAmount, '7.35vw', false)}
                        </>
                            : null
                    }
                    {/* {formState?.serviceSearchData?.is_sharable === true && (
                        <>
                            {textBox("Doctor share*", 'doctorShareRupee', formState?.doctorShareRupee, '15vw', false, 'rupee')}
                            {textBox("Doctor Percent*", 'doctorSharePercent', formState?.doctorSharePercent, '15vw', false, 'percent')}
                            {textBox("Hospital share*", 'hospitalShareRupee', formState?.hospitalShareRupee, '15vw', false, 'rupee')}
                            {textBox("Hospital Percent*", 'hospitalSharePercent', formState?.hospitalSharePercent, '15vw', false, 'percent')}
                        </>
                    )} */}
                    <Button variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} disabled={!commonDisable} onClick={() => {
                        setFormState((prevState) => ({
                            ...prevState,
                            serviceName: '',
                            serviceAmount: '',
                            serviceSearchData: null,
                            intervalAmount: 0,
                            intervalTime: null,
                            selectedUnit: ''
                        }));
                        setBillingDisplay((prev) => ({ ...prev, selectedBillingDisplay: 'Package Name' }))
                        setEditMode(false);
                    }}>Clear</Button>
                    <Button variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '0.5vw' }} disabled={!formState?.serviceSearchData && !commonDisable} onClick={() => { AddTable() }}>{formState?.serviceSearchData?.package_line_item_id ? 'Update' : 'Add'}</Button>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '40vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={
                        (((packageLineItem?.length === delIDs.length) || (delIDs.length === serviceDetails.length)) && apiDeleteIDs.length > 0)
                            ? "Are you sure? Deleting this will remove the entire package!"
                            : "Are you sure, Do you want to delete this item?"
                    }
                    DeleteN DeleteNotify={
                        (((packageLineItem?.length === delIDs.length) || (delIDs.length === serviceDetails.length)) && apiDeleteIDs.length > 0)
                            ? "If you remove this, the entire package will be deleted."
                            : "If you remove this, this could affect the entire Configuration."
                    }
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteIndivudualData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}